import { render, staticRenderFns } from "./DeleteAllModal.vue?vue&type=template&id=ca06a534&scoped=true&"
import script from "./DeleteAllModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAllModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca06a534",
  null
  
)

export default component.exports